import React from 'react';

export const ChevronRightIcon: React.FC<{ fill?: string }> = ({ fill = '#01336B' }) => (
    <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path
            d="M0.632396 0.101694C0.738905 -0.0338993 0.951923 -0.0338993 1.08506 0.101694L6.65015 5.76949C6.78328 5.90508 6.78328 6.09491 6.65015 6.23051L1.08506 11.8983C0.951923 12.0339 0.738905 12.0339 0.632396 11.8983C0.424425 11.6971 0.307824 11.5843 0.0998521 11.3831C-0.033284 11.2475 -0.033284 11.0305 0.0998521 10.922L4.91938 5.98644L0.0998521 1.07797C-0.033284 0.969491 -0.033284 0.752542 0.0998521 0.616949C0.307824 0.41573 0.424425 0.302914 0.632396 0.101694Z"
            fill={fill}
        />
    </svg>
);
